import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'tipoDecimal'
})
export class TipoDecimalPipe  implements PipeTransform {
  transform(value: any, decimal: number = 0): string {
    
    if(value == undefined || isNaN(value))
      return String(0);
    let regex = new RegExp (/[^0-9\.]/g)
    if(!regex.test(value) && value !=''){
      return String(parseFloat(value).toFixed(decimal));
    }else if(value == ''){
      return String(parseFloat("0.00").toFixed(decimal))
    }else{
      let cadena =  String(value) 
      return String(parseFloat(cadena.replace(regex,'')).toFixed(decimal))
    }
  }
  parse(value: string, decimal: number = 0): string {
    return String(parseFloat(value).toFixed(decimal));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/tipo-decimal.pipe.ts